import { connect } from 'react-redux';
import DataContainer from 'Util/Request/DataContainer';

import { history } from 'Route';
import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';

import BeautyAdventCalendarPage from './BeautyAdventCalendarPage.component';

import BeautyAdventCalendarQuery from 'Query/BeautyAdventCalendar.query';

export const mapDispatchToProps = dispatch => ({
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class BeautyAdventCalendarPageContainer extends DataContainer {
    state = {
        data: {},
        isLoading: false
    };

    containerFunctions = { };

    componentDidMount() {
        this._removeBreadcrumbs();
        this._changeMeta();
        this._changeHeaderState();

        this.requestData();
    }

    componentDidUpdate() {
        this._changeMeta();
        this._changeHeaderState();
    }

    _removeBreadcrumbs() {
        const { toggleBreadcrumbs } = this.props;

        toggleBreadcrumbs(false);
    }
    _changeMeta() {
        const { updateMeta } = this.props;

        updateMeta({ title: 'Beauty Advent Calendar' });
    }
    _changeHeaderState() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: CMS_PAGE,
            title: 'Beauty Advent Calendar',
            onBackClick: () => history.goBack()
        });
    }

    requestData() {
        this.setState({ isLoading: true });

        this.fetchData(
            [BeautyAdventCalendarQuery.getQuery()],
            this.onDataLoad,
            this.onDataError
        );
    }

    onDataLoad = ({ getBeautyAdvent }) => {
        this.setState({ data: { ...getBeautyAdvent }, isLoading: false });
    };

    onDataError = () => {
        this.setState({ isLoading: false });

        history.push('/');
    }

    render() {
        return (
            <BeautyAdventCalendarPage
                { ...this.state }
                { ...this.containerFunctions }
            />
        );
    }
}

export default connect(null, mapDispatchToProps)(BeautyAdventCalendarPageContainer);
